// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1PLKf","label":"CategoryService_label__1Z9xl","location":"CategoryService_location__3ougT"};